import styled from 'styled-components';

export const Base = styled.div`
	display: flex;
	flex: 1;
	overflow: hidden;
	height: 100vh;
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	align-items: center;
	justify-content: center;
	padding: 40px;
	text-align: center;
`;

export const Title = styled.h1`
	font-size: 24px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[1000]};
	margin-bottom: 16px;
`;

export const Info = styled.div`
	font-size: 14px;
	color: ${({ theme }) => theme.gray[600]};
	text-align: left;

	p {
		margin: 16px 0;
	}

	a {
		color: white;
		text-decoration: underline;
	}
`;
